// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dev-topbar{position:sticky;z-index:1;top:0;width:100%;height:64px;background-color:#011527}", "",{"version":3,"sources":["webpack://app/dev/DevTopbar/styles.css"],"names":[],"mappings":"AAAA,YACE,eAAgB,CAChB,SAAU,CACV,KAAM,CACN,UAAW,CACX,WAAY,CACZ,wBACF","sourcesContent":[".dev-topbar {\n  position: sticky;\n  z-index: 1;\n  top: 0;\n  width: 100%;\n  height: 64px;\n  background-color: rgb(1, 21, 39);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
